import * as React from 'react'
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native'
import { ControlProps, PulseOpsFormat, assets, replaceFileNameSEABillingChange, useMobile } from '@pulseops/common'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

export interface FileUploadData {
  fileName: string
  fileExtension: string
  size: number
  base64: string
  uploadedDate: Date
  file: File
}

type ImageMultiProps = ControlProps<FileUploadData[]> & {
  transactionType?: string
  maxNumFile?: number
  timeFormat?: string
  disabled?: boolean
}

export const ImgUploadMutiple = (props: ImageMultiProps) => {
  const { value, onChange, disabled } = props
  const { t } = useTranslation()
  const inputRef = React.createRef<HTMLInputElement>()
  const MB = 1048576
  const maxSize = 10 * MB
  const maxTotal = 50 * MB
  const maxFile = props.maxNumFile
  const validExtensions = ['PNG', 'JPG', 'JPEG', 'PDF', 'TIF', 'TIFF']
  const validExtensionsName = ['*.PDF', '*.PNG', '*.JPG', '*.JPEG', '*.TIF', '*.TIFF']
  const [errorMess, setErrorMess] = React.useState<string>('')
  const [currSize, setCurrSize] = React.useState<number>(0)
  const { isMobile } = useMobile()

  function isDateValid(dateString: string | number | Date) {
    const date = moment(dateString, 'DDMMYYYY')
    // The date string is valid.
    return date.isValid()
  }
  function checkString(string: string) {
    return /^[0-9]*$/.test(string)
  }
  const validateName = (data: string) => {
    const arr = data.split('_')
    if (arr.length < 3) return false
    if (data.length < 23) return false
    if (arr[0] !== 'PYC') return false
    if (arr[1] !== 'Seabank') return false
    if (arr[2].length !== 8) return false
    if (checkString(arr[3]) === false || checkString(arr[2]) === false) return false
    const time: string = arr[2]
    const timeArr = arr[2].split('')
    timeArr.splice(2, 0, '-')
    timeArr.splice(-4, 0, '-')
    return isDateValid(time)
  }

  const checkUpload = (files: FileUploadData[]) => {
    const file = files[0]
    const nameXLSX = file.fileName
    const nameXLSX1 = nameXLSX.substring(12, 20)
    const date = moment(nameXLSX1, 'DDMMYYYY').toDate()
    const datePase = moment(date)
    const nowDate = moment(new Date())
    if (!validExtensions.includes(file.fileExtension.toLocaleUpperCase())) {
      setErrorMess(t('message:MS990099', { files: validExtensions.join('/') }))
    } else if (value && value?.length === 1) {
      setErrorMess(t('message:MS990104'))
    } else if ([23, 24, 25, 26, 27, 28, 29].includes(file.fileName.length) && moment(datePase).isAfter(moment(nowDate))) {
      setErrorMess(t('message:MS990102', { date: moment(new Date()).format('DD/MM/YYYY') }))
    } else if (!validateName(file.fileName)) {
      setErrorMess(t('message:MS990098'))
    } else if (file.size >= maxSize) {
      setErrorMess(t('message:MS040004'))
    } else if (currSize + file.size >= maxTotal) {
      setErrorMess(t('message:MS990100'))
    } else if (maxFile && value && value.length >= maxFile) {
      setErrorMess(t('message:MS990100', { size: maxFile }))
    } else {
      onChange && onChange(value ? [...value, file] : [file])
      setCurrSize(currSize + file.size)
      setErrorMess('')
    }
  }

  const deleteItem = (i: number) => {
    setErrorMess('')
    const temp = value || []
    temp.splice(i, 1)
    onChange && onChange(temp)
  }

  const handleUpload = (files: FileList) => {
    const fileList: FileUploadData[] = []
    const fileLength = files.length
    for (let i = 0; i < files.length; i++) {
      const fileItem = files[i]
      const reader = new FileReader()
      const oldExtension = fileItem.name ? fileItem.name.slice(fileItem.name.lastIndexOf('.')) : ''
      const fileName = fileItem.name ? fileItem.name.slice(0, fileItem.name.lastIndexOf('.')) : ''
      //filter file name and replace special characters
      const filterNewName = replaceFileNameSEABillingChange(fileName)
      const fullFilterName = filterNewName + oldExtension.toLowerCase()
      const newFile = new File([fileItem], fullFilterName, { type: fileItem.type })
      const fileExt = newFile.name.split('.').pop() ?? ''
      reader.readAsDataURL(newFile)
      reader.onloadend = () => {
        fileList.push({
          fileName: newFile.name.split('.')[0],
          fileExtension: fileExt.toLowerCase(),
          size: newFile.size,
          base64: reader.result as string,
          uploadedDate: new Date(),
          file: newFile
        })
        i === fileLength - 1 && fileList.length > 0 && checkUpload(fileList)
      }
    }
  }
  const handleRenderIcon = (fileExtension: string) => {
    switch (fileExtension.toLowerCase()) {
      case 'pdf':
        return <assets.IconPdf />
      case 'jpeg':
        return <assets.IconJpeg />
      case 'jpg':
        return <assets.IconJpg />
      case 'png':
        return <assets.IconPng />
      case 'tif':
        return <assets.IconTif />
      case 'tiff':
        return <assets.IconTiff />
      default:
        return <assets.DocumentIcon />
    }
  }
  const ProxyView = isMobile ? View : ScrollView
  const composeContainerWidth = isMobile ? '100%' : 400
  const composeProxyView = '100%'
  return (
    <View>
      <View style={{ flexDirection: isMobile ? 'column' : 'row', marginTop: 10 }}>
        {!disabled && (
          <View style={{ width: composeContainerWidth }}>
            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity
                style={[styles.uploadContainer, { marginRight: 10 }]}
                // onPress={() => {
                //   upload()
                // }}
              >
                <assets.UploadCloud />
                <Text style={{ fontSize: 12 }}>{t('common:DropFileHere')}</Text>
                <Text style={{ fontSize: 12 }}>{t('common:or')}</Text>
                <Text style={{ fontSize: 12, color: '#ED1B1C' }}>{t('common:SelectFromComputer')}</Text>
                <input
                  ref={inputRef}
                  //hidden
                  style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    fontSize: 20,
                    cursor: 'pointer',
                    opacity: 0,
                    borderWidth: 1
                  }}
                  type="file"
                  multiple={false}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.target.files) {
                      handleUpload(event.target.files)
                      event.target.files = null
                      event.target.value = ''
                    }
                  }}
                  onDrop={(event: React.DragEvent<HTMLInputElement>) => {
                    event.preventDefault()
                    if (event.dataTransfer.files) {
                      handleUpload(event.dataTransfer.files)
                    }
                  }}
                />
              </TouchableOpacity>
              <TouchableOpacity style={[styles.uploadContainer, { marginBottom: 10 }]} disabled>
                <View style={{ marginBottom: 5 }}>
                  <assets.UploadCameraRed />
                </View>

                <Text style={{ fontSize: 12 }}>{t('common:TakeAPicture')}</Text>
              </TouchableOpacity>
            </View>
            <Text style={{ fontSize: 15, opacity: 0.6, fontStyle: 'italic', marginTop: 20 }}>
              {t('BillingChange:FormatFile', { fileExtension: validExtensionsName.join(', ') })}
            </Text>
            <Text style={{ fontSize: 15, opacity: 0.6, fontStyle: 'italic' }}>
              {t('BillingChange:MaximumFile', { fileExtension: '8MB' })}
            </Text>
          </View>
        )}
        <ProxyView
          style={{ width: composeProxyView, paddingVertical: isMobile ? 16 : 0, maxHeight: isMobile ? undefined : 250 }}
        >
          <View style={{ width: '100%', flexDirection: 'row', flexWrap: 'wrap' }}>
            {value &&
              value.map((file, i) => (
                <View style={styles.resultItem} key={`resultItem-${i}`}>
                  <View style={{ justifyContent: 'center' }}>{handleRenderIcon(file.fileExtension)}</View>
                  <View style={{ flexDirection: 'column', marginLeft: 10 }}>
                    <Text style={{ fontSize: 15 }}>
                      <Text> {file?.fileName && file.file.name} </Text>
                    </Text>
                    <Text style={{ fontSize: 15, fontStyle: 'italic', marginTop: 20 }}>
                      {PulseOpsFormat.datetoFormat(file.uploadedDate, props.timeFormat || 'DD/MM/YYYY HH:mm')}
                    </Text>
                  </View>
                  <View style={{ position: 'absolute', right: 0, paddingTop: 20, flexDirection: 'row' }}>
                    {!disabled && (
                      <TouchableOpacity
                        hitSlop={{ right: 20, left: 20, top: 20, bottom: 20 }}
                        onPress={() => deleteItem(i)}
                        style={{ padding: 5 }}
                      >
                        <assets.DeleteIcon />
                      </TouchableOpacity>
                    )}
                  </View>
                </View>
              ))}
          </View>
        </ProxyView>
      </View>
      <Text style={{ color: '#ED1B2C', fontSize: 15 }}>{errorMess}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  common: {
    height: 31,
    fontSize: 15,
    borderBottomWidth: 0
  },
  dashline: {
    borderBottomColor: '#D3DCE6',
    borderBottomWidth: 1
  },
  uploadContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    // font-size: 12px;
    // border: 1px dashed #D3DCE6,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#D3DCE6',
    borderRadius: 8,
    height: 156,
    width: '48%'
  },
  resultItem: {
    height: 70,
    width: 275,
    flexDirection: 'row',
    borderBottomColor: '#92B0B3',
    borderBottomWidth: 2,
    borderStyle: 'dashed',
    marginBottom: 10,
    marginHorizontal: 10
  }
})
